import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styled from '@emotion/styled';

interface ModernButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  icon?: ReactNode;
}

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #14395e;
  border-radius: 6px;
  background: #14395e;
  color: #fff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;

  &:hover:not(:disabled) {
    background: #1c5187;
    border-color: #1c5187;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const IconSlot = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  line-height: 1;
`;

export const ModernButton = ({ children, icon, type = 'button', ...rest }: ModernButtonProps) => (
  <StyledButton type={type} {...rest}>
    {icon ? <IconSlot>{icon}</IconSlot> : null}
    {children}
  </StyledButton>
);
